import "./baseConfig/font.css.ts.vanilla.mjs";
import "./tabs.css.ts.vanilla.mjs";
var a = "p273__tabs-e6af_fc1c09022__1x35jvy0";
export {
  a as tabsStyle
};
//# sourceMappingURL=tabs.mjs.map
